function scrollToTop() {
    window.scrollTo(0, 0)
}

export default scrollToTop